import {Box, FormControl, InputAdornment, OutlinedInput, Slider, Typography} from "@mui/material";
import PercentIcon from "@mui/icons-material/Percent";
import {ChangeEvent, useState} from "react";
import "./MeasurePercentageInput.css"

const _debounce = require('lodash/debounce');


interface Props {
    value: number
    setValue: (inputValue: number) => void
    implementedText: string
}

export function MeasurePercentageInput(props: Props) {
    const {
        value,
        setValue,
        implementedText
    } = props
    /**
     * props.setValue issues a http request to backend
     * To avoid http request spam during slider changes, debounce invocations
     */
    const [localValue, setLocalValue] = useState(value)
    const [sliderStateDebounceSetValue] = useState(() => _debounce(setValue, 300))
    const [inputStateDebounceSetValue] = useState(() => _debounce(setValue, 500))

    const maxPercentage = 100

    const handleSliderChange = (event: Event, sliderInput: number | number[]) => {
        const newValue = typeof sliderInput === "number" ? sliderInput : sliderInput[0]
        setLocalValue(newValue);
        sliderStateDebounceSetValue(newValue)
    };

    function handleInputChange(inputValue: number) {
        if (inputValue !== undefined) {
            const newValue = inputValue > maxPercentage ? maxPercentage : inputValue
            setLocalValue(newValue)
            inputStateDebounceSetValue(newValue)
        }
    }

    return (
        <div>
            <Typography>
                {implementedText}
            </Typography>
            <Box style={{display: "flex", flex: "auto 1", columnGap: "20px", alignItems: "center"}}>
                <Slider value={localValue}
                        aria-labelledby="input-slider"
                        onChange={handleSliderChange}
                        sx={{
                            color: 'success.main',
                            '& .MuiSlider-thumb': {
                                color: '#063342'
                            }
                        }}

                />
                <FormControl variant="outlined" className="form-control_input_percentage" sx={{minWidth: "100px"}}>
                    <OutlinedInput  endAdornment={<InputAdornment disablePointerEvents position="end"><PercentIcon/></InputAdornment>}
                                   onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange(+e.target.value)}
                        // https://stackoverflow.com/questions/30626094/remove-leading-zeros-from-input-type-number
                                   value={Number(localValue).toString()}
                                   type="number"

                    />
                </FormControl>
            </Box>
        </div>
    )
}